import { useState } from 'react'
import { TextField, Autocomplete, TableRow, TableCell, Button, Box } from '@mui/material'
import { FileUploadField } from '../../../pages/DataEntryPage/Fields/FileUploadField'
import FilePreviewField from '../Fields/FilePreviewField'
import { fileServices } from '../../../services/fileServices'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { additionalNotesService } from '../../../services/additionalNotesService'
import moment from 'moment'
import { formatUserDisplayName, formatUserFullName } from '../../../utility/userName'

const options = [
  { label: 'text', value: 'text' },
  { label: 'file', value: 'file' },
]

const EditingRowWrapper = ({
  note,
  processId,
  setPreview,
  addNewRow,
  activityTemplateName,
  version,
  onTypeChange,
  showActions,
}) => {
  const { user } = useAuthContext()
  const [updatedNote, setUpdatedNote] = useState(note)

  const handleFileUpload = async (e) => {
    let file = e.target.files[0]
    const result = (await fileServices.uploadFile(user, file)).data
    setUpdatedNote({ ...updatedNote, content: result?.filePath?.split('/')[1] || '' })
  }

  const handleSaveAdditionalNotes = async () => {
    if (!updatedNote?.data_structure || !updatedNote?.description) {
      return
    }

    const dataToSave = {
      process_id: processId,
      data_structure: updatedNote?.data_structure,
      description: updatedNote?.description || '',
      content: updatedNote?.content || '',
      activity_template_name: activityTemplateName,
      version: version,
    }

    if (note.id) {
      await additionalNotesService.editNotes(user, note.id, dataToSave)
      setPreview({
        ...note,
        ...dataToSave,
        user_id: user.id,
        modified_at: new Date(),
      })
    } else {
      const data = await additionalNotesService.saveAdditionalNotes(user, dataToSave)
      addNewRow({
        ...data,
        temp_id: note.temp_id,
        email: user.email,
        name: formatUserFullName(user),
        user_id: user.id,
        modified_at: new Date(),
        activity_template_name: activityTemplateName,
        version: version,
      })
    }
  }

  return (
    <>
      <TableRow>
        <TableCell>
          <Box sx={{ paddingBlock: 1 }}>
            <Autocomplete
              options={options}
              value={{ value: updatedNote?.data_structure, label: updatedNote?.data_structure }}
              fullWidth
              onChange={(e, newValue) => {
                const newType = newValue?.value
                const typeChanged = newType !== updatedNote?.data_structure
                setUpdatedNote({
                  ...updatedNote,
                  data_structure: newType,
                  content: typeChanged ? (newType === 'file' ? null : '') : updatedNote.content,
                })
                onTypeChange(newType)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  color="primary"
                  size="small"
                  label={'Type'}
                />
              )}
            />
          </Box>
        </TableCell>
        <TableCell>
          <Box sx={{ paddingBlock: 1 }}>
            <TextField
              fullWidth
              multiline
              size="small"
              variant="outlined"
              color="primary"
              label={'Note Description'}
              value={updatedNote?.description}
              minRows={1}
              onChange={(e) =>
                setUpdatedNote({
                  ...updatedNote,
                  description: e.target.value,
                })
              }
            />
          </Box>
        </TableCell>
        {updatedNote?.data_structure && updatedNote?.data_structure === 'file' ? (
          <TableCell>
            <Box sx={{ paddingBlock: 1, width: '100%' }}>
              {!updatedNote?.content?.length > 0 ? (
                <FileUploadField
                  id={note.id}
                  onChange={(e) => {
                    handleFileUpload(e)
                  }}
                  label="File Upload"
                  placeholder="Choose file"
                  disabled={false}
                  helperText="Upload a file"
                />
              ) : (
                <FilePreviewField
                  id={note.id}
                  value={updatedNote?.content}
                  download={() => fileServices.downloadFile(user, setUpdatedNote)}
                  clear={() =>
                    setUpdatedNote({
                      ...updatedNote,
                      content: null,
                    })
                  }
                  disabled={false}
                />
              )}
            </Box>
          </TableCell>
        ) : (
          <TableCell>
            <Box sx={{ paddingBlock: 1 }}>
              <TextField
                fullWidth
                multiline
                size="small"
                variant="outlined"
                color="primary"
                label={'Note'}
                value={updatedNote?.content}
                minRows={1}
                onChange={(e) => {
                  setUpdatedNote({
                    ...updatedNote,
                    content: e.target.value,
                  })
                }}
              />
            </Box>
          </TableCell>
        )}
        <TableCell>
          {user && (
            <>
              {note.activity_template_name} (version {note.version})
            </>
          )}
        </TableCell>
        <TableCell>
          {user && (
            <>
              {formatUserDisplayName(user)}
              <br />
            </>
          )}
        </TableCell>
        <TableCell>{user && <>{moment().format('DD MMM YYYY, HH:mm A')}</>}</TableCell>
        <TableCell>
          {showActions && (
            <Button
              color="primary"
              sx={{ height: 26 }}
              variant="outlined"
              onClick={handleSaveAdditionalNotes}
            >
              save
            </Button>
          )}
        </TableCell>
      </TableRow>
    </>
  )
}

export default EditingRowWrapper
